import { render, staticRenderFns } from "./ToggleThemeBtn.vue?vue&type=template&id=649488c9&"
import script from "./ToggleThemeBtn.vue?vue&type=script&lang=ts&"
export * from "./ToggleThemeBtn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports